import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
export function SalesPage() {
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.querySelector('#compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-yellow-200" data-id="element-5">
      <SocialProofPopup data-id="element-6" />

      {/* 1. URGENCY BAR */}
      <div className="sticky top-0 z-40 bg-red-600 text-white text-center py-1.5 px-4 font-bold text-xs shadow-md" data-id="element-7">
        ⏳ OFERTA EXPIRA EN: <CountdownTimer data-id="element-8" /> | 🔥 CUPOS LIMITADOS
      </div>

      <main className="pb-20" data-id="element-9">
        {/* 2. HERO SECTION */}
        <section className="pt-3 pb-8 px-4 max-w-3xl mx-auto text-center" data-id="element-10">
          <p className="text-[10px] md:text-xs font-semibold text-gray-500 mb-2 uppercase tracking-wide" data-id="element-11">
            👩 Para mujeres que quieren recuperar su autoestima y dejar de
            aceptar menos de lo que merecen
          </p>

          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3 leading-tight tracking-tight" data-id="element-12">
            MUJER DE ALTO VALOR
          </h1>

          <a href="#compra" onClick={scrollToCompra} className="block max-w-[260px] mx-auto mb-3 hover:scale-105 transition-transform duration-300" data-id="element-13">
            <img src="https://cdn.magicpatterns.com/uploads/erH5xxBYhvPkqXXWkEcH7N/cover.jpg" alt="Portada Mujer de Alto Valor" className="w-full h-auto rounded-lg shadow-2xl border border-gray-200" data-id="element-14" />
          </a>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 leading-snug" data-id="element-15">
            Cómo desarrollar seguridad emocional, establecer límites y construir
            relaciones donde te respeten.
          </h2>

          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-16">
            Todo lo que necesitás para dejar de sentir que das más de lo que
            recibís y empezar a construir relaciones sanas y equilibradas.
          </p>

          <p className="text-xl font-bold text-gray-900 mb-10" data-id="element-17">
            <span className="bg-yellow-200 px-2 py-1" data-id="element-18">
              Claro. Práctico. Transformador.
            </span>
          </p>

          <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" data-id="element-19" />

          <p className="mt-6 text-gray-600 font-medium flex items-center justify-center gap-2" data-id="element-20">
            ✅ Garantía de satisfacción de 7 días
          </p>
        </section>

        {/* 3. PAIN POINT SECTION */}
        <section className="py-8 px-4 bg-gray-50 border-y border-gray-200" data-id="element-21">
          <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-22">
            <p className="text-xl font-bold text-red-600 mb-3 text-center" data-id="element-23">
              Si estás leyendo esto, dejame hacerte una pregunta honesta
            </p>

            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center leading-tight" data-id="element-24">
              ¿Te pasó alguna vez sentir que en tus relaciones siempre terminás
              dando más de lo que recibís?
            </h3>

            <div className="space-y-3 text-lg md:text-xl text-gray-700" data-id="element-25">
              <p data-id="element-26">No porque seas débil. No porque no tengas valor.</p>
              <p data-id="element-27">Sino porque nadie te enseñó algo fundamental:</p>
              <p className="font-bold text-2xl text-gray-900 bg-yellow-100 inline-block px-2" data-id="element-28">
                Cómo poner límites emocionales y respetarte a vos misma.
              </p>
              <p data-id="element-29">Das apoyo. Escuchás. Comprendés. Estás presente.</p>
              <p data-id="element-30">Pero cuando necesitás lo mismo…</p>
              <p className="font-bold text-red-600 text-2xl" data-id="element-31">nadie aparece.</p>
              <p className="pt-2" data-id="element-32">
                Y entonces aparece esa pregunta silenciosa:
              </p>
              <p className="italic font-semibold text-2xl text-gray-900 text-center py-2" data-id="element-33">
                “¿Por qué siempre termino en relaciones así?”
              </p>
            </div>
          </div>
        </section>

        {/* 4. PROBLEM AGITATION */}
        <section className="py-8 px-4 max-w-3xl mx-auto" data-id="element-34">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-35">
            Tener relaciones sanas no debería sentirse tan difícil
          </h3>

          <p className="text-xl text-gray-700 mb-4 text-center" data-id="element-36">
            Pero hay un problema que casi nadie dice en voz alta:
          </p>

          <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6 rounded-r-lg" data-id="element-37">
            <p className="text-xl font-bold text-gray-900" data-id="element-38">
              👉 Muchas mujeres nunca aprendieron a establecer límites
              emocionales claros.
            </p>
          </div>

          <p className="text-lg text-gray-700 mb-3 font-medium" data-id="element-39">
            Y cuando eso pasa, ocurre algo muy común:
          </p>

          <ul className="space-y-2 mb-6 text-lg text-gray-700" data-id="element-40">
            <li className="flex items-start gap-3" data-id="element-41">
              <span className="text-red-500 font-bold" data-id="element-42">•</span>
              <span data-id="element-43">Aceptás cosas que no deberías aceptar</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-44">
              <span className="text-red-500 font-bold" data-id="element-45">•</span>
              <span data-id="element-46">Toleras comportamientos que te lastiman</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-47">
              <span className="text-red-500 font-bold" data-id="element-48">•</span>
              <span data-id="element-49">Te esforzás demasiado para demostrar tu valor</span>
            </li>
            <li className="flex items-start gap-3" data-id="element-50">
              <span className="text-red-500 font-bold" data-id="element-51">•</span>
              <span data-id="element-52">Sentís culpa cuando intentás priorizarte</span>
            </li>
          </ul>

          <div className="text-center space-y-2" data-id="element-53">
            <p className="text-xl font-bold text-gray-900" data-id="element-54">
              Lo peor no es la relación.
            </p>
            <p className="text-xl text-gray-700" data-id="element-55">
              Es esa sensación constante de:
            </p>
            <p className="text-2xl font-bold text-gray-900 italic" data-id="element-56">
              “Tal vez el problema soy yo.”
            </p>
            <p className="text-2xl font-extrabold text-green-600 pt-2" data-id="element-57">
              Pero no lo es.
            </p>
          </div>
        </section>

        {/* 5. SOLUTION SECTION */}
        <section className="py-8 px-4 bg-gray-900 text-white" data-id="element-58">
          <div className="max-w-3xl mx-auto text-center" data-id="element-59">
            <span className="inline-block bg-green-500 text-white font-bold px-4 py-1 rounded-full mb-3 text-lg" data-id="element-60">
              ✅ LA SOLUCIÓN
            </span>

            <h2 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 to-yellow-500 mb-4" data-id="element-61">
              MUJER DE ALTO VALOR
            </h2>

            <p className="text-xl md:text-2xl font-medium mb-4 leading-relaxed" data-id="element-62">
              Un sistema práctico diseñado para ayudarte a desarrollar seguridad
              emocional, autoestima real y límites claros en tus relaciones.
            </p>

            <p className="text-lg text-gray-300 mb-6" data-id="element-63">
              Un método claro para transformar la forma en que te relacionás con
              vos misma y con los demás.
            </p>

            <div className="bg-gray-800 rounded-xl p-6 mb-6 text-left md:text-center max-w-2xl mx-auto" data-id="element-64">
              <p className="text-xl mb-4" data-id="element-65">📂 Abrís el libro</p>
              <p className="text-xl mb-4" data-id="element-66">
                👀 Entendés tus patrones emocionales
              </p>
              <p className="text-xl font-bold text-yellow-400" data-id="element-67">
                ✍️ Aplicás herramientas reales en tu vida
              </p>
            </div>

            <p className="text-2xl font-bold text-white" data-id="element-68">
              Sin culpa. Sin confusión. Sin volver a aceptar menos de lo que
              merecés.
            </p>
          </div>
        </section>

        {/* 6. WHAT'S INCLUDED */}
        <section className="py-8 px-4 max-w-4xl mx-auto" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-70">
            📘 ¿Qué incluye exactamente MUJER DE ALTO VALOR?
          </h2>

          <div className="space-y-4 mb-8" data-id="element-71">
            <div className="flex gap-4 items-start" data-id="element-72">
              <span className="text-2xl" data-id="element-73">🔹</span>
              <div data-id="element-74">
                <h4 className="text-xl font-bold text-gray-900" data-id="element-75">
                  Cómo desarrollar seguridad emocional real
                </h4>
                <p className="text-gray-600 mt-1" data-id="element-76">
                  Aprendé a construir una autoestima que no dependa de la
                  aprobación de los demás.
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-77">
              <span className="text-2xl" data-id="element-78">🔹</span>
              <div data-id="element-79">
                <h4 className="text-xl font-bold text-gray-900" data-id="element-80">
                  Cómo establecer límites claros
                </h4>
                <p className="text-gray-600 mt-1" data-id="element-81">
                  Decir NO sin culpa ni miedo.
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-82">
              <span className="text-2xl" data-id="element-83">🔹</span>
              <div data-id="element-84">
                <h4 className="text-xl font-bold text-gray-900" data-id="element-85">
                  Cómo dejar de atraer relaciones que te desgastan
                </h4>
                <p className="text-gray-600 mt-1" data-id="element-86">
                  Identificá patrones emocionales que te mantienen atrapada.
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-87">
              <span className="text-2xl" data-id="element-88">🔹</span>
              <div data-id="element-89">
                <h4 className="text-xl font-bold text-gray-900" data-id="element-90">
                  Cómo construir relaciones donde te respeten
                </h4>
                <p className="text-gray-600 mt-1" data-id="element-91">
                  Transformá la dinámica de tus vínculos.
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-92">
              <span className="text-2xl" data-id="element-93">🔹</span>
              <div data-id="element-94">
                <h4 className="text-xl font-bold text-gray-900" data-id="element-95">
                  Cómo fortalecer tu autoestima verdadera
                </h4>
                <p className="text-gray-600 mt-1" data-id="element-96">
                  Dejá de depender de la validación externa.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-5 text-center" data-id="element-97">
            <p className="text-xl font-medium text-gray-800 mb-3" data-id="element-98">
              Todo explicado de forma clara, práctica y aplicable.
              <br data-id="element-99" />
              Para que puedas reconstruir tres pilares fundamentales:
            </p>
            <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 text-lg font-bold text-gray-900" data-id="element-100">
              <span data-id="element-101">✔ Autoestima emocional</span>
              <span data-id="element-102">✔ Límites claros</span>
              <span data-id="element-103">✔ Estándares personales</span>
            </div>
          </div>
        </section>

        {/* 7. ADDITIONAL CTA */}
        <section className="py-4 px-4" data-id="element-104">
          <CTAButton text="🔓 QUIERO TRANSFORMAR MIS RELACIONES AHORA" data-id="element-105" />
        </section>

        {/* 8. BEFORE VS AFTER */}
        <section className="py-8 px-4 bg-gray-50" data-id="element-106">
          <div className="max-w-5xl mx-auto" data-id="element-107">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-108">
              🔄 Antes vs Después
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-109">
              {/* Before */}
              <div className="bg-white rounded-2xl p-8 shadow-lg border-t-8 border-red-500" data-id="element-110">
                <h3 className="text-2xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-111">
                  ❌ Antes de MUJER DE ALTO VALOR
                </h3>
                <ul className="space-y-4 text-gray-700" data-id="element-112">
                  <li className="flex items-start gap-3" data-id="element-113">
                    <span className="text-red-500 mt-1" data-id="element-114">•</span>
                    <span data-id="element-115">Relaciones donde das más de lo que recibís</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-116">
                    <span className="text-red-500 mt-1" data-id="element-117">•</span>
                    <span data-id="element-118">Dificultad para decir NO</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-119">
                    <span className="text-red-500 mt-1" data-id="element-120">•</span>
                    <span data-id="element-121">Miedo a perder a alguien si ponés límites</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-122">
                    <span className="text-red-500 mt-1" data-id="element-123">•</span>
                    <span data-id="element-124">Autoestima dependiente de otros</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-125">
                    <span className="text-red-500 mt-1" data-id="element-126">•</span>
                    <span data-id="element-127">Sensación de no ser suficiente</span>
                  </li>
                </ul>
              </div>

              {/* After */}
              <div className="bg-white rounded-2xl p-8 shadow-xl border-t-8 border-green-500 transform md:-translate-y-4" data-id="element-128">
                <h3 className="text-2xl font-bold text-green-600 mb-6 flex items-center gap-2" data-id="element-129">
                  ✅ Después de MUJER DE ALTO VALOR
                </h3>
                <ul className="space-y-4 text-gray-900 font-medium" data-id="element-130">
                  <li className="flex items-start gap-3" data-id="element-131">
                    <span className="text-green-500 mt-1" data-id="element-132">✔</span>
                    <span data-id="element-133">Seguridad emocional real</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-134">
                    <span className="text-green-500 mt-1" data-id="element-135">✔</span>
                    <span data-id="element-136">Límites claros y respetados</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-137">
                    <span className="text-green-500 mt-1" data-id="element-138">✔</span>
                    <span data-id="element-139">Relaciones más sanas y equilibradas</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-140">
                    <span className="text-green-500 mt-1" data-id="element-141">✔</span>
                    <span data-id="element-142">Mayor autoestima y respeto propio</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-143">
                    <span className="text-green-500 mt-1" data-id="element-144">✔</span>
                    <span data-id="element-145">Tranquilidad emocional</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 9. BONUSES SECTION */}
        <section className="py-8 px-4 max-w-5xl mx-auto" data-id="element-146">
          <div className="text-center mb-6" data-id="element-147">
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-2" data-id="element-148">
              🎁 BONOS ESPECIALES
            </h2>
            <span className="inline-block bg-red-600 text-white font-bold px-4 py-1.5 rounded-full text-sm animate-pulse" data-id="element-149">
              GRATIS HOY
            </span>
          </div>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-150">
            {/* Bono 1 */}
            <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5" data-id="element-151">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-152">
                🎁 Bono #1 – 25 Frases Poderosas para Poner Límites Sin Sentirte
                Culpable
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-153">
                Aprendé exactamente qué decir cuando alguien intenta cruzar tus
                límites.
              </p>
              <div className="flex items-center gap-3" data-id="element-154">
                <span className="text-gray-400 line-through text-sm" data-id="element-155">
                  Valor: USD $17
                </span>
                <span className="font-bold text-green-600" data-id="element-156">HOY: GRATIS</span>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5" data-id="element-157">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-158">
                🎁 Bono #2 – Test Psicológico: ¿Estás Atrayendo Relaciones
                Desgastantes?
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-159">
                Descubrí si estás repitiendo patrones emocionales que te llevan
                a relaciones desequilibradas.
              </p>
              <div className="flex items-center gap-3" data-id="element-160">
                <span className="text-gray-400 line-through text-sm" data-id="element-161">
                  Valor: USD $19
                </span>
                <span className="font-bold text-green-600" data-id="element-162">HOY: GRATIS</span>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5" data-id="element-163">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-164">
                🎁 Bono #3 – Cómo Detectar a un Hombre Emocionalmente Inmaduro
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-165">
                Las señales tempranas que muchas mujeres ignoran.
              </p>
              <div className="flex items-center gap-3" data-id="element-166">
                <span className="text-gray-400 line-through text-sm" data-id="element-167">
                  Valor: USD $27
                </span>
                <span className="font-bold text-green-600" data-id="element-168">HOY: GRATIS</span>
              </div>
            </div>

            {/* Bono 4 */}
            <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5" data-id="element-169">
              <h3 className="text-lg font-bold text-gray-900 mb-1" data-id="element-170">
                🎁 Bono #4 – Reconstrucción de Autoestima en 7 Días
              </h3>
              <p className="text-gray-600 text-sm mb-3" data-id="element-171">
                Ejercicios prácticos para aplicar lo aprendido.
              </p>
              <div className="flex items-center gap-3" data-id="element-172">
                <span className="text-gray-400 line-through text-sm" data-id="element-173">
                  Valor: USD $25
                </span>
                <span className="font-bold text-green-600" data-id="element-174">HOY: GRATIS</span>
              </div>
            </div>
          </div>
        </section>

        {/* 10. PACKAGE SUMMARY + PRICING */}
        <section id="compra" className="py-8 px-4 bg-yellow-50 border-y-4 border-yellow-400 scroll-mt-10" data-id="element-175">
          <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-2xl p-6 md:p-8 border border-gray-100" data-id="element-176">
            <h2 className="text-3xl font-extrabold text-center text-gray-900 mb-4 pb-4 border-b border-gray-200" data-id="element-177">
              📦 Lo que recibís hoy
            </h2>

            <div className="space-y-3 mb-6 text-lg md:text-xl font-medium text-gray-800" data-id="element-178">
              <p className="flex items-center gap-3" data-id="element-179">
                <span className="text-green-500 text-2xl" data-id="element-180">✔</span> Ebook
                completo MUJER DE ALTO VALOR
              </p>
              <p className="flex items-center gap-3" data-id="element-181">
                <span className="text-green-500 text-2xl" data-id="element-182">✔</span> Bono #1:
                Frases para poner límites
              </p>
              <p className="flex items-center gap-3" data-id="element-183">
                <span className="text-green-500 text-2xl" data-id="element-184">✔</span> Bono #2:
                Test de relaciones
              </p>
              <p className="flex items-center gap-3" data-id="element-185">
                <span className="text-green-500 text-2xl" data-id="element-186">✔</span> Bono #3:
                Guía de red flags emocionales
              </p>
              <p className="flex items-center gap-3" data-id="element-187">
                <span className="text-green-500 text-2xl" data-id="element-188">✔</span> Bono #4:
                Workbook de autoestima
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-4 mb-6 text-sm font-bold text-gray-600 bg-gray-50 p-3 rounded-lg" data-id="element-189">
              <span className="flex items-center gap-1" data-id="element-190">
                ✔ Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-191">
                ✔ Descarga digital
              </span>
              <span className="flex items-center gap-1" data-id="element-192">
                ✔ Acceso de por vida
              </span>
            </div>

            <div className="text-center mb-6" data-id="element-193">
              <p className="text-2xl text-gray-500 line-through mb-2 font-medium" data-id="element-194">
                💰 Precio regular: $49.990
              </p>
              <p className="text-xl font-bold text-red-600 mb-1" data-id="element-195">
                🔥 HOY SOLO:
              </p>
              <p className="text-6xl md:text-7xl font-extrabold text-gray-900 tracking-tight" data-id="element-196">
                $19.990
              </p>
            </div>

            <CTAButton text="👉 OBTENER MUJER DE ALTO VALOR AHORA" href="https://pagos.crecerdigital.shop/cart/42883213394009:1" data-id="element-197" />

            <div className="mt-6 flex justify-center items-center gap-2 text-gray-500 font-medium" data-id="element-198">
              <span data-id="element-199">🔒 Pago 100% seguro</span>
            </div>
          </div>
        </section>

        {/* 11. GUARANTEE */}
        <section className="py-8 px-4 bg-gray-900 text-white text-center" data-id="element-200">
          <div className="max-w-2xl mx-auto" data-id="element-201">
            <div className="text-5xl mb-3" data-id="element-202">🛡️</div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-yellow-400" data-id="element-203">
              🔒 Garantía sin riesgo
            </h2>
            <p className="text-xl mb-4 font-medium" data-id="element-204">Probalo durante 7 días.</p>
            <p className="text-lg text-gray-300 mb-6" data-id="element-205">
              Si no sentís que este libro te da claridad emocional y
              herramientas reales para mejorar tus relaciones…
            </p>
            <p className="text-2xl font-bold mb-4" data-id="element-206">
              te devolvemos el 100% del dinero.
            </p>
            <p className="text-xl text-gray-400 italic" data-id="element-207">Sin preguntas.</p>
          </div>
        </section>

        {/* 12. TESTIMONIALS */}
        <section className="py-8 px-4 max-w-5xl mx-auto bg-white" data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-209">
            💬 Lo que dicen otras mujeres
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-210">
            {[{
            text: 'Por primera vez entendí por qué repetía los mismos patrones en mis relaciones.',
            author: 'Carolina M. – 32 años'
          }, {
            text: 'Me ayudó muchísimo a aprender a decir NO sin sentir culpa.',
            author: 'Valeria R. – 28 años'
          }, {
            text: 'Este libro cambió la forma en que me veo a mí misma.',
            author: 'Lucía P. – 35 años'
          }, {
            text: 'Dejé de aceptar relaciones que no me hacían bien.',
            author: 'Mariana S. – 30 años'
          }, {
            text: 'Es claro, práctico y muy poderoso emocionalmente.',
            author: 'Natalia G. – 41 años'
          }, {
            text: 'Ojalá hubiera leído esto hace 5 años. Me habría ahorrado mucho dolor.',
            author: 'Agustina L. – 27 años'
          }, {
            text: 'Aprendí a valorarme y a no conformarme con migajas emocionales.',
            author: 'Florencia D. – 34 años'
          }, {
            text: 'Lo más valioso fue entender que merezco relaciones donde me respeten.',
            author: 'Romina T. – 38 años'
          }, {
            text: 'Simple, directo y transformador. Lo recomiendo a todas mis amigas.',
            author: 'Daniela V. – 29 años'
          }, {
            text: 'Me dio las herramientas que necesitaba para dejar de repetir los mismos errores.',
            author: 'Celeste B. – 36 años'
          }].map((testimonial, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-100 shadow-sm" data-id="element-211">
                <div className="flex text-yellow-400 mb-3" data-id="element-212">
                  {'★★★★★'.split('').map((star, j) => <span key={j} data-id="element-213">{star}</span>)}
                </div>
                <p className="text-gray-800 font-medium mb-4 italic" data-id="element-214">
                  "{testimonial.text}"
                </p>
                <p className="text-gray-500 text-sm font-bold" data-id="element-215">
                  — {testimonial.author}
                </p>
              </div>)}
          </div>
        </section>

        {/* 13. FAQ */}
        <section className="py-8 px-4 max-w-3xl mx-auto" data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-6" data-id="element-217">
            ❓ Preguntas frecuentes
          </h2>

          <div className="space-y-4" data-id="element-218">
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-219">
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-220">
                ¿Es un libro motivacional?
              </h4>
              <p className="text-gray-600" data-id="element-221">
                No. Es un sistema práctico con herramientas aplicables.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-222">
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-223">
                ¿Es material digital?
              </h4>
              <p className="text-gray-600" data-id="element-224">
                Sí. Recibís acceso inmediato después de comprar.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-225">
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-226">
                ¿Sirve aunque ya haya intentado mejorar mi autoestima?
              </h4>
              <p className="text-gray-600" data-id="element-227">
                Sí. El enfoque está en cambiar patrones emocionales profundos.
              </p>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-228">
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-229">
                ¿Cuánto tiempo lleva aplicarlo?
              </h4>
              <p className="text-gray-600" data-id="element-230">
                Podés empezar a aplicar las herramientas desde el primer día.
              </p>
            </div>
          </div>
        </section>

        {/* 14. FINAL CTA */}
        <section className="py-10 px-4 bg-gray-50 text-center border-t border-gray-200" data-id="element-231">
          <div className="max-w-3xl mx-auto" data-id="element-232">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-233">
              Convertirte en una mujer segura puede ser más simple
            </h2>

            <p className="text-xl text-gray-700 mb-4" data-id="element-234">
              No necesitás cambiar quién sos.
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6 bg-yellow-100 inline-block px-4 py-1" data-id="element-235">
              Necesitás reconocer tu valor y aprender a protegerlo.
            </p>

            <CTAButton text="👉 Accedé ahora a MUJER DE ALTO VALOR" className="mb-6" data-id="element-236" />

            <p className="text-xl text-gray-600 italic font-medium" data-id="element-237">
              Porque cuando una mujer aprende a respetarse…
              <br data-id="element-238" />
              <span className="text-gray-900 font-bold" data-id="element-239">
                el mundo empieza a tratarla diferente.
              </span>
            </p>
          </div>
        </section>
      </main>
    </div>;
}